import React from 'react';
import {
  loadHomeData,
  // loadCardInsertLiteData,
  // loadCrosswordData,
} from 'routes/toiplushome/redux';
// import { commonHeadScriptsMobile } from 'helpers/scripts/headScripts';
import { getSiteConfig } from 'reduxUtils/modules/common';
import { setNavDataInGlobalObj } from 'utils/cdpUtils';
import Layout from 'components_v2/desktop/Layout';
// CARD-3692: temporary disabled
// import { loadDefaultUtilityBeltData } from 'components_v2/common/UtilityBeltV2/redux';
import ToipHomePage from '../../components/common/ToipHomePage/ToipHomePage';
import { loadLayoutDataTOIP } from '../../../../reduxUtils/modules_v2/layout';
import ToipAllStoriesBtn from '../../components/common/ToipAllStoriesBtn';
// import makeRequest from 'utils/makeRequest';

const pageName = 'prime_hp';

async function action(context) {
  const dataPromiseArray = [];
  const localParams = { 0: context.path };
  let state = context.store.getState();
  const isPrime = !!state.isPrime;
  const cd8 = '';
  const isAppView = state.isFrmapp;
  const isWapView = false;
  const newParams = {
    ...localParams,
    fullPath: context.path,
    isWapView,
    // templateName: 'toiplusauthor',
    // hideMobileTopBar: true,
    skipSubSections: true,
    isAppView,
  };

  // Layout data calls start

  if (!isAppView && (!state.header.data || !state.footer_v2.data)) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataTOIP(newParams)),
    );
  }

  if (!state.toiplushome.contentsData) {
    dataPromiseArray.push(context.store.dispatch(loadHomeData(newParams)));
  }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // if (!state.toiplushome.cardsInsertsLite) {
  //   dataPromiseArray.push(context.store.dispatch(loadCardInsertLiteData()));
  // }
  // if (!state.toiplushome.crosswordData) {
  //   dataPromiseArray.push(context.store.dispatch(loadCrosswordData()));
  // }
  // CARD-3692: temporary disabled
  // if (!state.utilityBelt.utilityBeltData && isPrime) {
  //   dataPromiseArray.push(context.store.dispatch(loadDefaultUtilityBeltData()));
  // }
  // Layout data calls end

  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  if (typeof window !== 'undefined') {
    let categoryForGA = 'WEB';
    if (isWapView) {
      categoryForGA = 'mWEB';
    }
    categoryForGA += `-CL-${window.location.pathname}`;
    window.categoryForGA = categoryForGA;
  }

  // get updated state
  state = context.store.getState();

  let status = 200;
  const title = 'Get Latest News Updates from The Times Of India';
  const dataAvailable = Boolean(state.toiplushome.contentsData);
  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  const toiplusHomePageSeo = state.toiplushome?.seo || {};

  const getTopImageForPreload = arr => {
    let imgUrl = '';
    if (Array.isArray(arr) && arr.length) {
      arr.forEach(item => {
        if (item?.isLead === 'featured') {
          imgUrl = `https://static.toiimg.com/thumb/imgsize-${item?.image
            ?.imagesize || '123456'},msid-${
            item?.image?.id
          },width-600,resizemode-4/${item?.image?.id}.jpg`;
        }
      });
    }
    return imgUrl;
  };
  const getSubPreload = arr => {
    const imgUrl = [];
    if (Array.isArray(arr) && arr.length > 0) {
      arr.forEach(item => {
        if (item?.tn === 'tplead_col_4_list_inner') {
          if (Array.isArray(item.items) && item.items.length > 0) {
            item.items.forEach(colItem => {
              if (colItem.isSubLead === 'subfeatured')
                imgUrl.push(
                  `https://static.toiimg.com/thumb/imgsize-${colItem?.image
                    ?.imagesize || '123456'},msid-${
                    colItem?.image?.id
                  },width-328,resizemode-4/${colItem?.image?.id}.jpg`,
                );
            });
          }
        }
      });
    }
    return imgUrl;
  };

  let sectionList = [];
  let topStorySection;
  let showPreload = false;
  let imageInfo = [];
  if (dataAvailable) {
    if (typeof window === 'object') {
      setNavDataInGlobalObj(null, { Tmpl_SCN: 'home', SCN: 'toi-plus' });
    }
    sectionList = state.toiplushome.contentsData.sections;
    //Extract first top stories tn form image preload
    if (Array.isArray(sectionList) && sectionList.length > 0) {
      sectionList.every(section => {
        if (section?.tn === 'tpcol_8_4_layout') {
          topStorySection = section;
          return false;
        }
        return true;
      });
      if (
        Array.isArray(topStorySection?.items) &&
        topStorySection.items.length > 0
      ) {
        topStorySection.items.forEach(item => {
          if (item?.tn === 'tplead_col_4_list') {
            const imgUrlArr = getSubPreload(item.items);
            if (Array.isArray(imgUrlArr) && imgUrlArr.length > 0) {
              imageInfo = [...imgUrlArr, ...imageInfo];
            }
          } else {
            const imgUrl = getTopImageForPreload(item.items);
            if (imgUrl) {
              imageInfo.push(imgUrl);
            }
          }
        });
        // imageInfo.push(`https://static.toiimg.com/photo/69822060.cms`);
        // imageInfo.push(`https://static.toiimg.com/photo/89937430.cms`);
        showPreload = imageInfo instanceof Array && imageInfo.length > 0;
      }
    }
  }
  const getComponent = pageTitle => {
    if (!dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com/toi-plus">here</a> to
          browse TOI Plus Content
        </div>
      );
    }

    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        rhs={false}
        hideBreadcrumAtBottom
        hideGetAppWidget
        hideGetAppBtn
        skipAds
        hideAdCude
        headerClass="fix-header-zero"
        pageType="toiplushomepage"
        layoutClass="toipLayout toiplushomepage"
        toipLayout
      >
        <ToipHomePage
          params={newParams}
          cardsInsertsLite={state.toiplushome.cardsInsertsLite}
          isWapView={false}
          location={context.pathname}
          showCollage={context.query && context.query.showCollage !== undefined}
          isPrime={isPrime}
        />
        <ToipAllStoriesBtn isWapView={false} />
      </Layout>
    );
  };
  // const gtmIDForOptimisely = ['GTM-KCRX3PN'];

  return {
    chunks: ['toiplushomedesktop'],
    title,
    seoData: {
      ...toiplusHomePageSeo,
      schema: state.toiplushome?.schema || [],
    },
    status,
    component: getComponent(title),
    maxAge: 300,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    preconnectDomains: [],
    // gtmIDList: gtmIDForOptimisely,
    headTags: [],
    skipColumbiaScript: true,
    skipImaScript: true,
    skipPubmaticScript: true,
    skipPageViewGAOnLoad: true,
    skipRouteAds: true,
    useVariableFonts: true,
    inlineFirstFoldCSS: true,
    isPerfExperimented: true,
    TOIPlusRoute: true,
    showPreload,
    imageInfo,
  };
}

export default action;
